import React, { useState, useEffect } from 'react';
import sanityClient from '../../sanity-client.js';
import { Link } from 'react-router-dom';
import SvgIcon from '../library/SvgIcon/SvgIcon.js';

import NavLinkDelay from '../NavLinkDelay';

import Headroom from 'react-headroom';
import cx from 'classnames';

import './style.scss';

const Navigation = () => {
  const [isMobileMenuOpen, setMobileMenuBool] = useState(false);
  const [navigationData, setNavigationData] = useState();

  const handleMobileMenuClick = () => setMobileMenuBool(!isMobileMenuOpen);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "navigation" && navId.current == "main-nav"] {
					items[] {
						navigationItemUrl {
							internalUrl,
							externalUrl,
							internalLink -> {
								slug,
							}
						},
						text,
					}
				}`
      )
      .then((data) => setNavigationData(data[0]))
      .catch(console.error);
  }, []);

  return (
    <Headroom className={`menu ${isMobileMenuOpen && 'mobile-menu--open'}`} upTolerance={2}>
      <nav className="nav-container">
        <Link to="/" aria-label="homepage" className="brand-logo">
          <SvgIcon icon={'logo_gold'} />
        </Link>
        <div className="menu-items">
          <ul>
            {navigationData &&
              navigationData.items.map((item, index) => {
                const pathTo = item.navigationItemUrl;

                const linkGroupClasses = cx({
                  'link--white': isMobileMenuOpen,
                  'link--blue': !isMobileMenuOpen
                });

                // prettier-ignore
                if (pathTo.internalUrl) {
                  return (
										<li key={index}>
											<NavLinkDelay to={pathTo.internalUrl}  className={linkGroupClasses}>
												{item.text}
											</NavLinkDelay>
										
										</li>
									)
                } 
								else if (pathTo.internalLink.slug.current) {
                  return (
										<li key={index}>
											<NavLinkDelay to={pathTo.internalLink.slug.current}  className={linkGroupClasses}> 
												{item.text}
											</NavLinkDelay>
										</li>
									)
                } 
								else {
                  return (
										<li key={index}>
											<NavLinkDelay to={pathTo.internalLink.externalUrl}  className={linkGroupClasses}>
												{item.text}
											</NavLinkDelay>
										</li>
									)
                }
              })}
          </ul>

          <div className="header__networking">{/* <SocialLinks /> */}</div>
        </div>

        <div className={'hamburger-menu'} tabIndex="0" aria-label="Open navigation menu" onClick={handleMobileMenuClick}>
          <SvgIcon icon={'hamburger_menu'} />
        </div>
      </nav>
    </Headroom>
  );
};

export default Navigation;
